import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminDeleteTranslationMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminDeleteTranslationMutationResultFragment, AdminDeleteTranslationMutationParams } from '@docpace/admin-graphql'

const typedAdminDeleteTranslationMutationDocument = AdminDeleteTranslationMutationDocument as TypedDocumentNode<AdminDeleteTranslationMutationResultFragment, Partial<AdminDeleteTranslationMutationParams>>

export function useAdminDeleteTranslationMutation(opts?: useMutation.Options<AdminDeleteTranslationMutationResultFragment, Partial<AdminDeleteTranslationMutationParams>>){
    return useMutation(typedAdminDeleteTranslationMutationDocument, opts)
}
